import React from 'react';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

import { StyledDrawerFooter, StyledCancelButton } from './BudgetDrawer.styles';

type SharedBudgetDrawerFooterProps = {
  handleCancel: () => void;
  handleSave: () => void;
  handleTertiaryAction?: () => void;
  tertiaryButtonText?: string;
  cancelDisabled?: boolean;
  saveDisabled?: boolean;
};

const SharedBudgetDrawerFooter = ({
  handleCancel,
  handleSave,
  handleTertiaryAction,
  tertiaryButtonText,
  cancelDisabled,
  saveDisabled,
}: SharedBudgetDrawerFooterProps) => (
  <StyledDrawerFooter>
    {tertiaryButtonText && handleTertiaryAction && (
      <ButtonV3 variant="secondary" onClick={handleTertiaryAction}>
        {tertiaryButtonText}
      </ButtonV3>
    )}
    <StyledCancelButton variant="secondary" onClick={handleCancel} disabled={cancelDisabled}>
      Cancel
    </StyledCancelButton>
    <ButtonV3 onClick={handleSave} disabled={saveDisabled}>
      Save
    </ButtonV3>
  </StyledDrawerFooter>
);

export default SharedBudgetDrawerFooter;
